import { dispatch, state } from '__common/store';
import { ADD_ENDING_POINT, ADD_STARTING_POINT, START_NEW_MEASUREMENT } from '__editor/googleMapsRoofsSelector/components/measurementTool/measurementToolActions';

export function measurementToolClick(renderer: PIXI.CanvasRenderer | PIXI.WebGLRenderer, stage: PIXI.Container) {
  const interaction = (renderer.plugins as any)?.interaction;
  if (interaction?.eventData?.data !== null) {
    const globalPoint = interaction.eventData.data.global;

    // for delete button click only
    const hitObject = interaction.hitTest(globalPoint, stage);
    if (hitObject && hitObject.interactive && hitObject.name === 'measurementToolInteractive') {
      return;
    }

    const { measurementTool : { enabled, startingPoint } } = state();
    const coords = stage.toLocal(globalPoint);
    if (enabled && coords) {
      if (startingPoint){
        dispatch(START_NEW_MEASUREMENT());
      } else {
        dispatch(ADD_STARTING_POINT(coords));
      }
    }
  }
}

export function measurementToolMove(renderer: PIXI.CanvasRenderer | PIXI.WebGLRenderer, stage: PIXI.Container) {
  const interaction = (renderer.plugins as any)?.interaction;
  if (interaction?.eventData?.data !== null) {
    const globalPoint = interaction.eventData.data.global;
    const { measurementTool : { enabled, startingPoint } } = state();
    const coords = stage.toLocal(globalPoint);
    if (enabled && startingPoint && coords && coords.x && coords.y) {
      dispatch(ADD_ENDING_POINT(coords));
    }
  }
}
